export default {
  "backToStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tillbaka till start"])},
  "proceed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nästa"])},
  "emailRegisteration": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmäl dig till vårt nyhetsbrev"])},
    "invalidEmail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vänligen ange en giltig e-postadress!"])},
    "emailAddress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postadress..."])}
  },
  "interestedLanguages": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vilka språk är du intresserad av?"])},
    "any": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allt"])},
    "AFew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Några"])}
  },
  "selectlanguages": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj de språk du är intresserad av ..."])}
  },
  "personalDescriptions": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Det som bäst beskriver dig?"])},
    "teacher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jag är en lärare"])},
    "librarian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jag är bibliotekarie"])},
    "purchaser": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jag är en köpare"])},
    "other": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Övrig"])}
  },
  "sendInformation": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vill du att vi skickar information om vårt företag eller bara om böcker som vi tycker är intressanta?"])},
    "yeahSure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Snälla gör det"])},
    "noThanks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bara om böcker"])}
  },
  "askedcontact": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kan vi kontakta dig för att veta mer om dina behov? Det hjälper oss att förbättra vårt sortiment och service."])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja, ring gärna"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nej, tack"])}
  },
  "phoneNumberRegisteration": {
    "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fyll i ett telefonnummer..."])}
  },
  "thankYou": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tack!"])},
    "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Du har nu prenumererat"])}
  },
  "recaptcha": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta att prenumerera"])}
  }
}